<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="1200px"
    >
      <div style="margin-bottom: 20px">
        <span>时间：{{ showData() }}</span>
      </div>

      <el-table v-if="visible" v-loading="loading" :data="list" :default-sort="sort" border @sort-change="handleSortChange">
        <el-table-column type="index" label="排行" width="70" align="center" :index="(index)=> (index+1) + (pageNum-1)*pageSize" />
        <el-table-column label="门店商家" prop="dataName" align="center" />
        <el-table-column label="系统估价量" prop="assessCount" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <el-table-column label="询价量" prop="inquiryCount" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <!-- <el-table-column prop="highestQuoteNum" label="最高报价量" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
      <el-table-column prop="highestQuoteRatio" label="最高报价率" align="center" sortable="custom" :sort-orders="['descending', 'ascending']">
        <template slot-scope="{ row }">
          <span>{{ row.highestQuoteRatio||0 }}%</span>
        </template>
      </el-table-column> -->
        <el-table-column label="成交量" prop="dataCount" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <el-table-column label="成交率" prop="dataRate" align="center" sortable="custom" :sort-orders="['descending', 'ascending']">
          <template slot-scope="{ row }">
            {{ row.dataRate }}%
          </template>
        </el-table-column>
        <el-table-column label="交易金额" prop="dealAmount" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <el-table-column label="补贴金额" prop="renewSubsidyPriceAll" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
      </el-table>
      <Pagination :pageNum.sync="pageNum" :pageSize.sync="pageSize" :total="total" @pagination="getData" />
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { brandOrPriceOrderDownTypes, getSortForm } from '../table/define'
import Pagination from '../Pagination.vue';

export default {
  name: "BrandOrPriceStoreDia",
  components: { Pagination },
  inject: ['showData'],
  props: {
    title: String,
    form: {
      type: Object,
      default: () => ({})
    },
    sort: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],
      sortForm: {},
      row: {}
    };
  },
  methods: {
    open(row) {
      this.row = row
      this.sortForm = getSortForm(this.sort, brandOrPriceOrderDownTypes)
      this.pageNum = 1
      this.visible = true
      this.getData()
    },
    getData() {
      this.loading = true
      _api.brandPriceRankDown({
        ...this.form,
        ...this.sortForm,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        key: this.row.key,
        channel: 'company'
      }).then(res => {
        this.list = res.data.records
        this.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleSortChange({ order, prop }) {
      // this.sort = { order, prop }

      const sortForm = getSortForm({ order, prop }, brandOrPriceOrderDownTypes)
      this.sortForm = sortForm
      this.getData()
    },
  }
};
</script>